<template>
  <el-container>
    <el-form ref="ruleForm" :model="ruleForm" label-width="120px" :rules="rules">
      <el-form-item label="设备类型" prop="device_type_id">
        <el-select v-model="ruleForm.device_type_id" @change="deviceTypeIdChange">
          <el-option
            v-for="item in share.device_typeList"
            :key="item.value"
            :label="item.text"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="系统名称" prop="server_type" ref="server_type">
        <el-select v-model="ruleForm.server_type">
          <el-option
            v-for="item in share.serverVersionList"
            :key="item.value"
            :label="item.key"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="系统文件" prop="file_name">
        <input type="file" accept=".zip" ref="fileInput" @change="(e)=>getFile(e, 'file_name')" class="selectFile" />
        <el-input v-model="ruleForm.file_name" readonly >
          <el-button type="warning" slot="prepend">选择文件</el-button>
        </el-input>
      </el-form-item>
      <el-form-item label="MD5校验文件" prop="md5_file_name">
        <input type="file" accept=".txt" ref="md5fileInput" @change="(e)=>getFile(e, 'md5_file_name')" class="selectFile" />
        <el-input v-model="ruleForm.md5_file_name" readonly >
          <el-button type="warning" slot="prepend">选择文件</el-button>
        </el-input>
      </el-form-item>
      <el-form-item label="版本号" prop="version">
        <el-input v-model="ruleForm.version" placeholder="例如: V1.0.0.0" />
      </el-form-item>
      <el-form-item label="发布内容" prop="comment">
        <el-input v-model="ruleForm.comment" type="textarea" :rows="10" maxlength="512" show-word-limit />
      </el-form-item>
      <el-form-item>
        <el-button class="btn_dialog" @click="$emit('tableCloseDialog')">取消</el-button>
        <el-button class="btn_dialog cz" @click="resetForm">重置</el-button>
        <el-button class="btn_dialog qd" @click="confirm">确认</el-button>
      </el-form-item>
    </el-form>
  </el-container>
</template>

<script>
import Backend from '@/api/backend'
import BasicDataHelper from '@/api/basic_data_helper'
import GlobalData from '@/api/global_data'
import md5 from 'js-md5'
const reader = new FileReader()

export default {
  name: '',
  data () {
    return {
      ruleForm: {
        server_type: '',
        file_name: '',
        md5_file_name: '',
        version: '',
        device_type_id: '',
        comment: ''
      },
      rules: {
        server_type: [
          { required: true, message: '请选择系统名称', trigger: 'change' }
        ],
        file_name: [
          { required: true, message: '请选择系统文件', trigger: 'change' }
        ],
        md5_file_name: [
          { required: true, message: '请选择MD5校验文件', trigger: 'change' }
        ],
        version: [
          { required: true, message: '请输入版本号', trigger: 'blur' },
          {
            // pattern: /^(V|v)([1-9]\d|[1-9])(.([1-9]\d|\d)){3}$/,
            pattern: /^(V|v)([1-9]\d*)(.([1-9]\d*|[0]{1,1})){3}$/,
            message: '请输入有效的版本号'
          }
        ],
        device_type_id: [
          { required: true, message: '请选择设备类型', trigger: 'change' }
        ],
        comment: [
          { required: true, message: '请输入发布内容', trigger: 'blur' }
        ]
      },
      share: {
        serverVersionList: [],
        device_typeList: []
      },
      file_: null,
      md5file_: null,
      md5: '',
      txtcontent: ''
    }
  },
  created () {
    this.getDeviceTypeList()
  },
  mounted () {
    reader.addEventListener('load', this.md5Made)
  },
  destroyed () {
    reader.removeEventListener('load', this.md5Made)
    console.log(9999)
  },

  methods: {
    getDeviceTypeList () {
      Backend.filterKeyValueList(this, 'device_type')
    },
    deviceTypeIdChange (id) {
      this.$refs.server_type.resetField()
      this.share.serverVersionList = BasicDataHelper.getServerVersion(this, id)
    },
    // 获取文件数据
    getFile (e, key) {
      // 这就是你上传的文件
      const file = e.target.files[0]
      this.ruleForm[key] = file.name
      this[key === 'file_name' ? 'file_' : 'md5file_'] = file
      switch (key) {
        case 'file_name':
          reader.readAsArrayBuffer(file) // 生成md5
          break
        case 'md5_file_name':
          reader.readAsText(file, 'UTF-8') // 读取txt
          break
      }
    },
    md5Made (e) { // 获取md5
      var res = e.target.result
      if (typeof res === 'object') this.md5 = md5(res)
      if (typeof res === 'string') this.txtcontent = res
    },
    resetForm () {
      this.$refs.ruleForm.resetFields()
      this.$refs.fileInput.value = ''
      this.$refs.md5fileInput.value = ''
      this.file_ = null
      this.md5file_ = null
    },
    validateMd5 () {
      return this.md5.indexOf((this.txtcontent).trim())
    },
    confirm () {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          if (this.validateMd5() === -1) {
            this.$message.error('所选文件与md5不匹配!')
            return
          }
          const form = { ...this.ruleForm }
          form[form.file_name] = this.file_
          form[form.md5_file_name] = this.md5file_

          const loading = this.$loading({
            lock: true,
            text: '文件上传中...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.3)'
          })

          Backend.post(this, 'version_manage/package_upload', form).then((data) => {
            loading.close()
            this.$message.success('新建成功!')
            const pageData = GlobalData.tabShareData['升级列表'].pageData
            if (pageData) {
              pageData.items.unshift(data)
              pageData.total += 1
            }
            this.$emit('tableCloseDialog')
          }).catch(e => {
            loading.close()
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .selectFile{
    opacity: 0;
    width: 85px;
    height: 32px;
    z-index: 10;
    position: absolute;
    left: 0;
    top: 0;
  }
</style>
